import React from "react";
import { Navigate, Route, Routes } from "react-router-dom";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import ScrollToTop from "./common/ScrollToTop";
import LandingPage from "./views/landingPage/LandingPage";
import QNA from "./views/QNA/QNA";
import QNATest from "./views/QNA";
import ThankyouVersion1 from "./views/ThankyouVersion1";
import Report from "./views/report/Report";
import ReportB from "./views/ReportBackup";
import PrivacyPolicy from "./views/landingPage/PrivacyPolicy";
import { PersistGate } from 'redux-persist/integration/react'
import { Provider } from 'react-redux';
import { persistor, store } from "./store/store";
import { NotFound } from "./views/NotFound";
import ThankyouBackup from "./views/ThankyouBackup";

function App() {
  return (
    <Provider store={store}>
      <PersistGate loading={null} persistor={persistor}>
        <ScrollToTop>
          <ToastContainer position="top-right" autoClose={5000} />
          <Routes>
            {/* Group survey route - must be before generic /:survey_id */}
            <Route exact path="/G/:group_id/:survey_id" element={< LandingPage />}> </Route>
            <Route exact path="/:survey_id" element={< LandingPage />}> </Route>
            <Route exact path=":survey_id/privacy-policy" element={< PrivacyPolicy />}> </Route>
            <Route exact path="/qna/:survey_id/:ss_id" element={< QNA />}> </Route>
            <Route exact path="/thank-you/:survey_id/:ss_id" element={< ThankyouVersion1 />}> </Route>
            <Route exact path="/report/:survey_id/:ss_id/:srid" element={< Report />}> </Route>
            <Route exact path="/report-bakup/" element={< ReportB />}> </Route>
            <Route exact path="/thankyou-bakup/" element={< ThankyouBackup />}> </Route>
            <Route exact path="/qna-bakup/" element={< QNATest />}> </Route>

            <Route exact path="/not-found/" element={< NotFound />}> </Route>
            <Route exact path="/" element={<Navigate to={'not-found'}> </Navigate>}> </Route>
            <Route exact path="*" element={<Navigate to={'not-found'}> </Navigate>}> </Route>
          </Routes>
        </ScrollToTop>
      </PersistGate>
    </Provider >
  );
}

export default App;
